// extracted by mini-css-extract-plugin
export default {"variant-history-modal":"VariantHistoryModal_variant-history-modal__cbudR","header-wrapper":"VariantHistoryModal_header-wrapper__z1WZg","content":"VariantHistoryModal_content__2EsWf"};